import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RotateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Rotate",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.89 16.13c-1.07 0-1.94.87-1.94 1.94v.03c0 4.37-3.54 7.91-7.91 7.91s-7.91-3.54-7.91-7.91 3.52-7.89 7.87-7.91v3.21c0 .57.47 1.03 1.04 1.03.28 0 .54-.11.73-.3l5.19-5.19c.19-.19.3-.45.3-.73s-.12-.55-.3-.73l-5.19-5.17c-.19-.19-.45-.3-.73-.3s-.55.12-.73.3c-.19.19-.3.44-.3.73v3.22c-6.56 0-11.87 5.31-11.87 11.87S9.45 30 16.01 30s11.87-5.31 11.87-11.87v-.06c0-1.07-.87-1.94-1.94-1.94h-.04Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.11 12.14h-8a1.14 1.14 0 1 1 0-2.28h6.86V3a1.14 1.14 0 1 1 2.28 0v8c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 29.29c-7.56 0-13.71-6.15-13.71-13.71S8.01 1.86 15.57 1.86c9.75 0 13.44 8.34 13.59 8.69a1.142 1.142 0 1 1-2.1.9c-.13-.3-3.27-7.31-11.49-7.31-6.3 0-11.43 5.13-11.43 11.43S9.27 27 15.57 27c3.88 0 7.47-1.95 9.59-5.21.34-.53 1.05-.68 1.58-.33s.68 1.05.33 1.58a13.67 13.67 0 0 1-11.5 6.25"
      })]
    })
  }));
};
RotateIcon.displayName = 'RotateIcon';